import { useNavegate } from 'App/hooks';
import { InfoDomainCard, InfoDomainCardSkeleton } from 'commons/components';
import { configurationsRoutes } from 'domains/Configurations';
import { useDomainSuggestionByName } from 'domains/Configurations/Domains/hooks';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface DomainSuggestionCardProps {
  onClose?: () => void;
}

export function DomainSuggestionCard({
  onClose,
}: Readonly<DomainSuggestionCardProps>) {
  const t = useTranslationConfigurations('domains.editModal.suggestion');
  const { goTo } = useNavegate();
  const { recommendation, isLoading, storeName } = useDomainSuggestionByName();

  const handleClickWithoutRecommendation = () => {
    onClose?.();
    goTo(`${configurationsRoutes.domains}?openSearch=true`);
  };

  const handleClickWithRecommendation = () => {
    onClose?.();
    goTo(`${configurationsRoutes.domains}?search=${storeName}.com`);
  };

  if (isLoading) return <InfoDomainCardSkeleton />;

  const hasRecommendation =
    !!recommendation && recommendation.availability.available;

  if (!hasRecommendation) {
    return (
      <InfoDomainCard
        title={t('title')}
        description={t('description')}
        onClick={handleClickWithoutRecommendation}
      />
    );
  }

  return (
    <InfoDomainCard
      title={t('titleWithDomain', { domain: recommendation.domainName })}
      description={t('descriptionWithPrice', {
        price: recommendation.price.settledAmount?.value,
      })}
      onClick={handleClickWithRecommendation}
    />
  );
}
